

import { convertCdnResizeUrl } from '@/utils'
import { getCapturedImageUrl } from '~/scriptData/common/interM2'
import CommonImage from '~/components/common/CommonImage.vue'

export default {
  components: { CommonImage },
  props: {
    unitType: { // component 노출 타입
      type: String,
      default: ''
    },
    revwAvg: { // 리뷰 평점
      type: String,
      default: '0'
    },
    pdNo: { // 품번
      type: String,
      default: ''
    },
  },
  data () {
    return {
      selOpt: { // qna 조회 폼
        pageSize: 24, // 한페이지 당 노출 건수
        currentPage: 1 // 조회 페이지
      },
      cttsList: [], // 리뷰 컨텐츠 리스트
      revwCttsSwipeOpt: { // 23.08.16 실시간 포토리뷰 스와이퍼 추가
        slidesPerView: 12,
        spaceBetween: 8,
        lazy: true,
        navigation: {
          nextEl: '.review-photo .photo-list .swiper-button-next',
          prevEl: '.review-photo .photo-list .swiper-button-prev'
        }
      },
      // 23.08.16 리뷰 내부 사진& 동영상 스와이퍼 추가
      revwCttsSwipeOpt2: {
        slidesPerView: 8,
        spaceBetween: 8,
        lazy: true,
        navigation: {
          nextEl: '.tab-cont.review .photo-list .swiper-button-next',
          prevEl: '.tab-cont.review .photo-list .swiper-button-prev'
        }
      },
      totalCnt: 0,
    }
  },
  async mounted () {
    await this.selRevwCtts()
  },
  methods: {
    getCapturedImageUrl,
    // 리뷰 컨텐츠 리스트 조회
    async selRevwCtts () {
      this.selOpt.pdNo = this.pdNo
      try {
        await this.$AxiosBuilder
          .data({ pdNo: this.pdNo, ...this.selOpt })
          .build()
          .post('/pd/pds/revw/selRevwCtts')
          .then((res) => {
            const result = res.data.data
            if (res.data.success) {
              this.cttsList = result
              this.totalCnt = result.length === 0 ? 0 : result[0].totalCnt // 리뷰 토탈 갯수
              this.$emit('setRevwCttsCnt', this.cttsList.length)
              this.$emit('revwCttsList', { cttsList: this.cttsList, totalCnt: this.totalCnt })
            }
          })
      } catch (e) {
        console.log('PdRevwCttsSwiper watch error : ', e)
      }
    },
    convertCdnResizeUrl (url, resize) {
      return convertCdnResizeUrl(url, resize)
    },

    // 리뷰 상세 보기 레이어 팝업
    openLayerRevwDtl (revwMngNo) {
      this.$emit('openLayerRevwDtl', { name: 'revwDtl', data: { revwMngNo } })
    },
    // 사진 & 동영상 컨텐츠 전체보기(팝업)
    openLayerRevwCttsClt () {
      this.$emit('openLayerRevwCttsClt', { name: 'revwCttsClt', data: { pdNo: this.pdNo } })
    }
  }
}
